module.exports = __webpack_public_path__ + "img/hangzhou_scout.b5dac5fe.gif";